import { render, staticRenderFns } from "./OCButtonSmall.html?vue&type=template&id=6c5b41ce&scoped=true&"
import script from "./OCButtonSmall.ts?vue&type=script&lang=ts&"
export * from "./OCButtonSmall.ts?vue&type=script&lang=ts&"
import style0 from "./OCButtonSmall.css?vue&type=style&index=0&id=6c5b41ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b41ce",
  null
  
)

export default component.exports